<div class="container">
    <h1>404</h1>
    <p>Oops! The page you're looking for doesn't exist.</p>
    <a href="/signin" class="back-home">Go Back Home</a>
</div>